import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { setupCookieBlocking } from '@/lib/cookieManager';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Controlla se l'utente ha già fatto una scelta
    const cookieConsent = sessionStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Mostra il banner dopo un breve delay per non essere invasivo
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (cookieConsent === 'rejected') {
      // Se già rifiutato, assicurati che il blocco sia attivo
      setupCookieBlocking();
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    sessionStorage.setItem('cookieConsent', 'rejected');
    setupCookieBlocking(); // Attiva il blocco dei cookie di tracciamento
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] animate-slide-up">
      <div className="mx-auto max-w-7xl px-4 pb-4 sm:px-6 lg:px-8">
        <div className="rounded-lg border border-border bg-card/95 backdrop-blur-sm p-4 shadow-lg sm:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground">
                Questo sito utilizza solo cookie tecnici necessari per il funzionamento. 
                Non utilizziamo cookie di profilazione o tracciamento.{' '}
                <a 
                  href="/cookie-policy" 
                  className="text-primary hover:underline"
                >
                  Maggiori informazioni
                </a>
              </p>
            </div>
            <div className="flex items-center gap-3 sm:shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={handleReject}
                className="border-border text-muted-foreground hover:bg-muted hover:text-foreground"
              >
                Rifiuta
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={handleAccept}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Accetta
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

